import Image from "next/image";

const UspRoadmap = () => {
  return (
    <>
      <div className="mx-auto w-full xl:px-0 md:px-6 lg:!px-6 px-0 md:bg-bottom bg-center  bg-white square_grid_bg md:pt-[60px] md:pb-[70px] pt-8 pb-0 relative">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative md:block flex flex-col justify-center items-center">
          <h2 className="font-semibold md:text-[32px] text-[20px]  text-[#000] text-center mb-12 md:block hidden">
            Timeline{" "}
            <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2 leading-normal tracking-[-1.44px]">
              of your US Journey
            </span>
          </h2>
          <h2 className="font-semibold 2xl:text-[36px] md:text-[32px] text-[20px]  text-[#000] text-center mb-12 md:hidden block">
            Timeline of your US Journey
            {/* <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
              (Fall ‘26 Candidates)
            </span> */}
          </h2>

          <div className="md:mt-12 md:px-0 px-4">
            {/* {activeTab === "students" ? ( */}
            <>
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/desktop_timeline_new.webp"
                alt="Accounting salary in the usa"
                className="md:block hidden "
                width={1491}
                height={400}
                priority
              />
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/mobile_timeline_new.webp"
                alt="Accounting salary in the usa"
                className="block md:hidden "
                width={466}
                height={610}
                priority
              />
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default UspRoadmap;
